export const queries = {
  desktop: '(min-width:1024px)',
  // desktop: '(min-width:1024px) and (min-height:768px)',
  mobile: '(max-width:1023px)'
};

export const toggleVideoPlayBack = (type, $video) => {
  if($video.length > 0) {
    if(type === 'enter') {
      $($video).get(0).play();
    }

    if(type === 'leave') {
      $($video).get(0).pause();
    }
  }
}


export const updateHash = (id) => {
  let target = '#' + id;

  if(id === 'landing-default') {
    target = ' ';
  }

  history.replaceState(null, document.title, target);
}

export const resetParentWidth = ($container) => {
  $container.css({width: ''});
}

export const setParentWidth = ($container, node) => {
  const $section = $container.children(node);
  let totalWidth = 0;

  $section.each((i, el) => {
    const $this = $(el);
    totalWidth += $this.outerWidth(true);
  });

  $container.width(Math.ceil(totalWidth));
}



export const setHeight = ($container) => {
  const windowHeight = $(window).innerHeight();
  $container.height(windowHeight);
}



export const objectFitter = (parent, children) => {

  if (!Modernizr.objectfit || (/Edge/.test(navigator.userAgent) && children === 'video')) {

    $(parent).each(function() {
      //set size
      var th = $(this).height(),//box height
          tw = $(this).width(),//box width
          im = $(this).children(children),//image
          ih = im.height(),//inital image height
          iw = im.width();//initial image width
      if (ih>iw) {//if portrait
          im.css({width: '100%', height: 'auto'});//set width 100%
      } else {//if landscape
          im.css({width: 'auto', height: '100%'});//set height 100%
      }
      //set offset
      var nh = im.height(),//new image height
          nw = im.width(),//new image width
          hd = (nh-th)/2,//half dif img/box height
          wd = (nw-tw)/2;//half dif img/box width
      if (nh<nw) {//if portrait
          im.css({marginLeft: '-'+wd+'px', marginTop: 0});//offset left
      } else {//if landscape
          im.css({marginTop: '-'+hd+'px', marginLeft: 0});//offset top
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/js/utils/Utils.js